import { Component } from "@angular/core";
import { ServiceDataService } from "../service/service-data.service";
import { Service } from "../models/service";
import { State } from "@progress/kendo-data-query";
import { tap } from "rxjs/operators";
import { DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { EnvironmentServiceDataService } from '../service/environment-service-data.service';
import { ServiceConfigurationKeysDataService } from '../service/service-configuration-keys-data.service';
import { ExternalEditGridComponent } from 'src/app/core/external-edit-grid.component';

@Component({
  selector: "app-services",
  templateUrl: "./services.component.html",
  styleUrls: ["./services.component.scss"],
})
export class ServicesComponent extends ExternalEditGridComponent<Service> {
  public gridState: State = {
    sort: [
      {
        field: "Name",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 10,
  };

  constructor(
    private dataService: ServiceDataService,
    private envServiceDataService: EnvironmentServiceDataService,
    private configKeysDataService: ServiceConfigurationKeysDataService,
    private dialogService: DialogService
  ) 
  {
    super(Service);
  }

  protected refresh() {
    this.view = this.dataService
      .get(this.gridState, "")
      .pipe(tap(() => (this.loading = false)));
  }

  public saveHandler(service: Service) {
    this.loading = true;
    this.refreshObservable(this.dataService.update(service, this.isNew));    

    this.editItem = undefined;
  }

  public async removeHandler({ dataItem }) {
    const deleteAction = { text: "Delete", primary: true };
    const cancelAction = { text: "Cancel" };

    this.envServiceDataService.linkCount(+dataItem.Id)
    .subscribe(ec => 
      {
        if (+ec['@odata.count'] > 0) {
          let phrase = 'environment';
          if (+ec['@odata.count'] > 1) {
            phrase = phrase + 's';
          }
          this.dialogService.open({
            title: "Cannot Delete",
            content: `This service is associated with ${ec['@odata.count']} ${phrase}`,
            actions: [cancelAction],
          });
          return;
        }

        this.configKeysDataService.keyCountByService(+dataItem.Id)
        .subscribe(kc => 
          {
            if (+kc['@odata.count'] > 0) {
              let phrase = 'configuration key';
              if (+kc['@odata.count'] > 1) {
                phrase = phrase + 's';
              }
              this.dialogService.open({
                title: "Cannot Delete",
                content: `This service has ${kc['@odata.count']} ${phrase}`,
                actions: [cancelAction],
              });
              return;
            }

            const dialog: DialogRef = this.dialogService.open({
              title: "Please confirm",
              content: "Deleting this service cannot be undone.",
              actions: [cancelAction, deleteAction],
            });
        
            dialog.result.subscribe((result) => {
              if (result === deleteAction) {
                this.refreshObservable(this.dataService.delete(dataItem.Id));
              }
            });            
          });
      });
  }
}
